import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { AnnouncementListProps } from "./types";
import { EntryOptions, PropertyDefinition, PropertyMappingType, } from "app/library/layout-builder";
import { MetaTypeEnum } from "app/shared";

import { CardPropertyDefinitions } from 'components/cms/definitions';

export class AnnouncementListDefinitions extends CmsReactComponent<AnnouncementListProps> {
    static schemaName = "announcement-list";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "announcements",
            description: "Announcement List Elemanları",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: CardPropertyDefinitions,
            },
            group: {
                key: "data",
                title: "Announcement Verileri",
                withObject: false,
            }
        },
        {
            name: "excludeEventType",
            text: "Listelenmesini istediğiniz etkinli türü",
            mapping: {
                type: PropertyMappingType.String
            }
        },
        {
            name: "eventGroup",
            text: "Listelenmesini istediğiniz etkinli grubu",
            mapping: {
                type: PropertyMappingType.String
            }
        },
        {
            name: "overrideOrder",
            text: "Tarihe göre sıralansın mı?",
            mapping: {
                type: PropertyMappingType.Boolean
            }
        },
        {
            name: "width",
            text: "Genişlik",
            description: "Kart Görsel Genişliği",
            mapping: {
                type: PropertyMappingType.Number
            }
        },
        {
            name: "height",
            text: "Yükseklik",
            description: "Kart Görsel Yüksekliği",
            mapping: {
                type: PropertyMappingType.Number
            }
        },
        {
            name: "anchorText",
            text: "Link metini",
            description: "İçeriğin yönlendirilmesi için kullanılacak metin",
            mapping: {
                type: PropertyMappingType.String
            }
        },
    ];

    static options: EntryOptions = {
        meta: {
            use: false,
            allowedTypes: [],
        },
        mappingFields: [
            {
                name: "title",
                text: "Duyuru Başlık",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "description",
                text: "Duyuru Açıklaması",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea, MetaTypeEnum.Editor],
            },
            {
                name: "datetime",
                text: "Duyuru Zaman Bilgisi",
                types: [MetaTypeEnum.Date, MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "content",
                text: "Duyuru İçeriği",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea, MetaTypeEnum.Editor],
            },
            {
                name: "anchor",
                text: "Card URL",
                types: [MetaTypeEnum.Link]
            },
        ],
    };
}
